import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-5 container" }
const _hoisted_2 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_ds_button = _resolveComponent("ds-button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('financial.history')), 1),
    _createVNode(_component_DataTable, {
      rows: _ctx.params.size,
      sortOrder: -1,
      value: _ctx.transactionsHistory,
      responsiveLayout: "scroll",
      sortField: "createdAT",
      showGridlines: ""
    }, {
      empty: _withCtx(() => [
        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('financial.noHistory')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          sortable: true,
          field: "createdAT",
          header: _ctx.$t('financial.buyDate'),
          removableSort: ""
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.createdAT)), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "amountCredit",
          header: _ctx.$t('financial.quantCredits'),
          sortable: true,
          removableSort: ""
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "storePrice",
          header: _ctx.$t('financial.value'),
          sortable: true,
          removableSort: ""
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.formatCurrency(slotProps.data.price)), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, { header: 'Status' }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.status == 'PENDING')
              ? (_openBlock(), _createBlock(_component_ds_button, {
                  key: 0,
                  text: _ctx.$t('utils.access'),
                  type: "tertiary",
                  leftIcon: "open_in_new",
                  onClick: ($event: any) => (_ctx.acessPaymentDetails(slotProps.data.referenceCheckout))
                }, null, 8, ["text", "onClick"]))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass('status-span status-' + (slotProps.data.status ? slotProps.data.status.toLowerCase() : ''))
                }, _toDisplayString(_ctx.paymentStatusCodes(slotProps.data.status)), 3))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rows", "value"]),
    _createVNode(_component_Paginator, {
      rows: _ctx.params.size,
      totalRecords: _ctx.params.total,
      onPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.paginate($event)))
    }, null, 8, ["rows", "totalRecords"])
  ]))
}